module.exports = __webpack_public_path__ + "static/230120_BUXE_Machbarkeitsstudie-47a18b99f437616e8b3f6aa874df75c2.pdf";